<div class="flex flex-row flex-wrap gap-8" *transloco="let t">
  @for (pack of packList; track pack.id) {
    <button
      class="flex flex-1 flex-col gap-2 rounded-lg border border-greyscale-100 p-10 shadow-lg"
      (click)="handleClick($index)"
      [ngClass]="{
        'border-primary-300': isSelected($index),
        'border-4': isSelected($index),
        'shadow-lg': true,
      }"
    >
      <!-- Header -->
      <div class="mb-6 text-center">
        <h4 class="text-primary-900">{{ pack.name }}</h4>

        <p class="mt-2 text-3xl font-bold text-primary-900">
          {{ pack.price }} €
        </p>

        <p class="text-xs text-greyscale-600">
          {{ t("subscription.pricePerYear") }}
        </p>
      </div>

      <!-- Description -->
      @if (pack.description) {
        <p class="mb-6 text-center text-paragraph-s-reg text-greyscale-700">
          {{ pack.description }}
        </p>
      }

      <!-- Limits -->
      <div
        class="mb-6 space-y-2 border-t border-greyscale-100 pt-4 text-paragraph-s-reg"
      >
        <div class="flex justify-between">
          <span>{{ t("subscription.tripsIncludedLabel") }}</span>
          <strong>{{ pack.tripLimit }}</strong>
        </div>

        <div class="flex justify-between">
          <span>{{ t("subscription.usersIncludedLabel") }}</span>
          <strong>{{ pack.userLimit }}</strong>
        </div>

        <div class="flex justify-between">
          <span>{{ t("subscription.extraUsersLabel") }}</span>
          <strong>
            @if (pack.extraUserLimit === null) {
              {{ t("subscription.unlimited") }}
            } @else {
              {{ pack.extraUserLimit }}
            }
          </strong>
        </div>
      </div>

      <!-- Features -->
      <div class="mb-8 border-t border-greyscale-100 pt-4">
        <ul class="space-y-2 text-paragraph-s-reg">
          <!-- Included in all packs -->
          <li class="flex justify-between">
            <span>{{ t("subscription.advancedEmissionCalculation") }}</span>
            <i
              class="pi pi-check font-medium text-green-600"
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.aiBrochureAnalysis") }}</span>
            <i
              class="pi pi-check font-medium text-green-600"
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.updatedEmissionFactors") }}</span>
            <i
              class="pi pi-check font-medium text-green-600"
              style="font-size: 0.75rem"
            ></i>
          </li>

          <!-- Pack-specific features -->
          <li class="flex justify-between">
            <span>{{ t("subscription.exportPdf") }}</span>
            <i
              class="pi font-medium"
              [ngClass]="
                pack?.exportPDF
                  ? 'pi-check text-green-600'
                  : 'pi-times text-red-500'
              "
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.exportExcel") }}</span>
            <i
              class="pi font-medium"
              [ngClass]="
                pack?.exportExcel
                  ? 'pi-check text-green-600'
                  : 'pi-times text-red-500'
              "
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.clientFilter") }}</span>
            <i
              class="pi font-medium"
              [ngClass]="
                pack?.clientFilter
                  ? 'pi-check text-green-600'
                  : 'pi-times text-red-500'
              "
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.comparisonGraph") }}</span>
            <i
              class="pi font-medium"
              [ngClass]="
                pack?.comparisonGraph
                  ? 'pi-check text-green-600'
                  : 'pi-times text-red-500'
              "
              style="font-size: 0.75rem"
            ></i>
          </li>

          <li class="flex justify-between">
            <span>{{ t("subscription.bulkUpload") }}</span>
            <i
              class="pi font-medium"
              [ngClass]="
                pack?.bulkUpload
                  ? 'pi-check text-green-600'
                  : 'pi-times text-red-500'
              "
              style="font-size: 0.75rem"
            ></i>
          </li>
        </ul>
      </div>

      <!-- CTA / Selected -->
      <div class="mt-auto">
        @if (isSelected($index)) {
          <div
            class="w-full rounded-md bg-primary-600 py-3 text-center text-paragraph-s-reg font-semibold text-white"
          >
            {{ t("subscription.selectedOffer") }}
          </div>
        } @else {
          <div
            class="w-full rounded-md border border-primary-200 py-3 text-center text-paragraph-s-reg font-semibold text-primary-700 group-hover:bg-primary-50"
          >
            {{ t("subscription.chooseOffer") }}
          </div>
        }
      </div>
    </button>
  }
</div>
